/**
 * Created by jpilz on 2/13/17.
 */
"use strict";
import {context} from '../../../objects/context.js';
import ko from 'knockout';
import jobUtil from '../../../objects/jobUtil.js';

import BootstrapDialog from 'bootstrap3-dialog/dist/js/bootstrap-dialog';

class component1Model {

    constructor(params) {
        // Profile
        this.componentName = "tabGeneral";
        this.context = context;
        this.id = "bd02e349-bf72-4f46-ad30-0e2bad2e872c";
        this.visible = ko.observable(true);

        this.selectedJob = params.selectedJob;

        this.optioncolumn1Visible = ko.observable(context.preferences().columnViewList.optioncolumn1Visible);
        this.optioncolumn2Visible = ko.observable(context.preferences().columnViewList.optioncolumn2Visible);
        this.optioncolumn3Visible = ko.observable(context.preferences().columnViewList.optioncolumn3Visible);
        this.optioncolumn4Visible = ko.observable(context.preferences().columnViewList.optioncolumn4Visible);
        this.optioncolumn5Visible = ko.observable(context.preferences().columnViewList.optioncolumn5Visible);
        this.optioncolumn6Visible = ko.observable(context.preferences().columnViewList.optioncolumn6Visible);

        this.context.preferences.subscribe( data => {
            console.log("tabGeneral:constructor:preferences.subscribe:");
            this.updateOptionColumn();
        });

    }

    updateOptionColumn() {

        console.log("nav-job-list:updateOptionColumn");
        this.optioncolumn1Visible(context.preferences().columnViewList.optioncolumn1Visible);
        this.optioncolumn2Visible(context.preferences().columnViewList.optioncolumn2Visible);
        this.optioncolumn3Visible(context.preferences().columnViewList.optioncolumn3Visible);
        this.optioncolumn4Visible(context.preferences().columnViewList.optioncolumn4Visible);
        this.optioncolumn5Visible(context.preferences().columnViewList.optioncolumn5Visible);
        this.optioncolumn6Visible(context.preferences().columnViewList.optioncolumn6Visible);
        
    }


    clickColumn1(item, event) {

        console.log("tabGeneral:clickColumn1 %o %o", item, event);
    }

    clickSave() {

        let jobUtilObj = new jobUtil(this.context);

        jobUtilObj.saveJob(this.selectedJob).then( response => {

            console.log('tabGeneral:clickSave:  response: %o', response );
            
            if(response.statusText == "OK")
            {
                BootstrapDialog.show({
                    title: 'SAVED',
                    message: 'Job was saved.',
                    type: BootstrapDialog.TYPE_SUCCESS,
                });
            } else 
            {
                BootstrapDialog.show({
                    title: 'Save Eror',
                    message: response.statusText,
                    type: BootstrapDialog.TYPE_DANGER,
                });
            }
            

            // Add Bootstrap Dialog Here 
            //alert("Job Saved");
            //this.context.eventManager.notifySubscribers({type:"saveJob", job:response },"jobRefresh");
        }).catch( (err) => {
            alert(err);
        });

    }

    handleJobDelete(item) {
        console.log('tabEditor:handleJobDelete item: %o', item );

        let self = this;
        let jobUtilObj = new jobUtil(this.context);

        BootstrapDialog.confirm({
            
            title: 'Job DELETE',
            id: 'tabGeneral-handleJobDelete-modal',
            message: 'Are you sure you want to DELETE this job?<br><br>This can NOT be undone.', 
            type: BootstrapDialog.TYPE_DANGER,
            btnOKLabel: 'DELETE',
            
            callback: function(result){

            if(result) {
                console.log('job-view:handleJobDelete result %o', result);
                jobUtilObj.jobDelete({jobid:self.selectedJob.jobid(), subid:self.selectedJob.subid()}).then( response => {
                    console.log('tabEditor:handleJobDelete:jobDelete response %o  result: %o', response, result);
                    jobUtilObj.getJobList(); 
                }).catch( response => {
                    console.log('tabEditor:handleJobDelete:jobDelete ERROR %o', response);
                });
                } 
            }

        });


    }

    handleJobSaveAs(item) {
        console.log('tabEditor:handleJobSaveAs item: %o', item );

        let self = this;
        let jobUtilObj = new jobUtil(this.context);

        BootstrapDialog.show({
            title: 'Job - Save As',
            message: 'New Job Title: <input type="text" value="' + self.selectedJob.title() + '" class="form-control">', 
            buttons: [{
                label: 'Save',
                action: function(result){

                    /*
                    then( response => {
                                jobUtilObj.getJobList();  
                            })
                    */

                    if(result) {

                        console.log('tabEditor:handleJobSaveAs Save: result %o', result);
                        console.log('tabEditor:handleJobSaveAs Save: input %o', result.getModalBody().find('input').val() );

                        let title = result.getModalBody().find('input').val();

                        if(title.length > 3)
                        {
                            console.log('tabEditor:handleJobSaveAs SaveAs: title %o jobid: %o', title, self.selectedJob.jobid() );

                            jobUtilObj.jobCopy({subid:self.selectedJob.subid(), jobid:self.selectedJob.jobid(), title:title}).then( response => {
                                console.log('tabEditor:handleJobSaveAs:jobCopy response %o  result: %o', response, result);
                                result.close();
                                jobUtilObj.getJobList();  
                                //self.context.eventManager.notifySubscribers({updateNav:true},"jobRefresh");
                            }).catch( response => {
                                console.log('tabEditor:handleJobSaveAs:jobCopy ERROR %o', response);
                            });
                            
                        }
                        else
                        {
                            alert('Job title required or Title length error');
                        }
                        
                    }
                }
            },{
                label: 'Cancel',
                action: function(result){

                    if(result) {
                        console.log('tabEditor:handleJobSaveAs Cancel: result %o', result);
                        result.close();
                    }
                }
            }]
        });
        
    }

}

export default { viewModel: component1Model, template: require('!raw-loader!./tabGeneral.html') };


// WEBPACK FOOTER //
// ./src/components/nav-job-list/tabGeneral/tabGeneral.js